/**
 * Datadog log events for merchant-dashboard popups, emitted centrally by
 * `useFeatureOnboardingManager` and aggregated by the admin popup-analytics
 * page into click and dismiss rates.
 *
 * These strings are a wire contract: changing one orphans every log already in
 * Datadog from the query that reads it. Rename only while the events exist
 * nowhere but local development.
 */
export enum PopupEvent {
  SHOWN = "popup.shown",
  CTA_CLICKED = "popup.cta_clicked",
  DISMISSED = "popup.dismissed",
  /** The CTA's follow-through finished, such as a call booked from a calendar. */
  CTA_CONFIRMED = "popup.cta_confirmed",
}

/**
 * Popups that run outside `useFeatureOnboardingManager`, so have no
 * `FeatureOnboardingType`, yet report the same events under this type.
 */
export enum StandalonePopupType {
  CREDIT_INCENTIVE = "credit_incentive",
}
